module.exports = __webpack_public_path__ + "static/media/pause.417dbfef.svg";